import { Component, OnInit, NgZone } from '@angular/core';
import { PatientService } from 'src/app/services/patient.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { PatientRemindersLoginDialogComponent } from 'src/app/dialogs/patient-reminders-login-dialog/patient-reminders-login-dialog.component';
import { LegacyContentService } from 'src/app/services/legacy-content.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';

declare var Ext: any;
declare let Zone: any;

@Component({
  selector: 'app-patientinfo',
  templateUrl: './patientinfo.component.html',
  styleUrls: ['./patientinfo.component.scss']
})
export class PatientinfoComponent implements OnInit {

  showconsultationbutton = false;

  constructor(public patient: PatientService, private ngZone: NgZone, private dialog: MatDialog,
              private legacyContent: LegacyContentService, private typeManager: TypeManagerService) { }

  ngOnInit(): void {
    this.patient.patientPopupEvent.subscribe(info => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = info;
      dialogConfig.data.displaymode = 'summary';
      dialogConfig.width = '80%';
//      dialogConfig.height = '90%';
      const dialogRef = this.dialog.open(PatientRemindersLoginDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    });
  }

  openPatient() {
    const thePatient = new Ext.CNPatient(this.patient.patientid);
    thePatient.on('itemLoaded', (item) => {
        const patientWindow = new Ext.CNPatientWindow({patient: item});
        patientWindow.on('patientUpdated', (updatedPatient) => {
          this.patient.updatePatient();
        }, this);
        patientWindow.show();
    });
  }

  openWaitingConsultation()
  {
//      this.compatjs.showConsultationWindow();
  }

  menuClick(menu)
  {
    if (typeof menu.pwa !== 'undefined') {
      if (typeof menu.pwa.content !== 'undefined') {
        this.legacyContent.SetComponent(menu.pwa.content);
      }
      if (typeof menu.pwa.dialog !== 'undefined') {
        if (this.typeManager.typeMap(menu.pwa.dialog)) {
          const componentFactory = this.typeManager.typeMap(menu.pwa.dialog);
          const dialogRef = this.dialog.open(componentFactory, {
              data: {
                patient: this.patient.patient
              }
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
      }
    } else {
      if (typeof menu.execute !== 'undefined') {
          // tslint:disable-next-line:no-eval
          eval(menu.execute);
      }
      if (typeof menu.loadcontent !== 'undefined') {
          if (typeof menu.loadcontent === 'string') {
            this.legacyContent.LoadContent(menu.loadcontent);
          } else {
            this.legacyContent.LoadContent(menu.loadcontent[0], menu.loadcontent[1], menu.loadcontent[2]);
          }
      }
    }
  }

  iconClick(menu)
  {
    if (typeof menu.pwa !== 'undefined') {
      if (typeof menu.pwa.content !== 'undefined') {
        this.legacyContent.SetComponent(menu.pwa.content);
      }
      if (typeof menu.pwa.dialog !== 'undefined') {
        if (this.typeManager.typeMap(menu.pwa.dialog)) {
          const componentFactory = this.typeManager.typeMap(menu.pwa.dialog);
          const dialogRef = this.dialog.open(componentFactory, {
              data: {
                patient: this.patient.patient
              }
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
      }
    } else {
      if (typeof menu.execute !== 'undefined') {
          // tslint:disable-next-line:no-eval
          eval(menu.execute);
      }
      if (typeof menu.loadcontent !== 'undefined') {
          if (typeof menu.loadcontent === 'string') {
            this.legacyContent.LoadContent(menu.loadcontent);
          } else {
            this.legacyContent.LoadContent(menu.loadcontent[0], menu.loadcontent[1], menu.loadcontent[2]);
          }
      }
    }
  }
}
